import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntScrollingLayerComponent} from "./int-scrolling-layer.component";
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntScrollingLayerComponent
  ],
  exports: [
    IntScrollingLayerComponent
  ]
})
export class IntScrollingLayerModule {}
